import _ from 'lodash'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { setLocale } from 'ducks/app'
import l8n, { getLocaleFromPath, getUrlWithoutLocale, switchHtmlLocale, prefixPath } from 'l8n'
import qs from 'qs'
 
const mapStateToProps = (state) => ({
  locale: state.app.locale
})

@connect(mapStateToProps)
@withRouter
class Localizer extends React.Component {
    constructor(props) {
        super(props)
        const { dispatch, location } = this.props
        
        const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true })
        if (
          !!queryParams.lang
          &&
          !_.isEmpty(l8n.locales[queryParams.lang])
        ){
          l8n.queryLocale = queryParams.lang
        }
            
        // Изначальная локаль в урле
        l8n.urlLocale = getLocaleFromPath(location.pathname)
        l8n.urlLocale = !!l8n.locales[l8n.urlLocale] ? l8n.urlLocale : false
        
        // Локаль браузера
        l8n.browserLocale = (navigator.language || navigator.userLanguage).split('-')[0]
        l8n.browserLocale = !!l8n.locales[l8n.browserLocale] ? l8n.browserLocale : false

        // Финальная локаль
        //console.log(l8n.queryLocale, l8n.urlLocale, l8n.browserLocale)
        const finalLocale = l8n.queryLocale || l8n.urlLocale || l8n.browserLocale

        // Если локаль передана get-параметром
        // или в url отсутствует локаль в виде /{:locale}/...
        if (!!l8n.queryLocale || !l8n.urlLocale) {
            // Вставляем в url финальную локаль
            //console.log('Pushing locale', finalLocale, getUrlWithoutLocale(location.pathname))
            const prefixedLocation = prefixPath(getUrlWithoutLocale(location.pathname), finalLocale)
            const redirectPath = `${prefixedLocation}${location.search}`

            this.props.history.push(redirectPath)
            l8n.urlLocale = finalLocale
        }
        
        // Выставляем локаль
        this.setLocale(finalLocale, true)
        dispatch(setLocale({ value: finalLocale, url: !!l8n.urlLocale }))

        this.props.history.listen(location => {
            l8n.urlLocale = getLocaleFromPath(location.pathname)
            this.setLocale(l8n.urlLocale)
        })
        return true
    }
 
    setLocale(newLocale, force = false) {
        if (force || newLocale !== this.props.locale) {
            l8n.load(newLocale)
            switchHtmlLocale(newLocale)
        }
    }
 
    render() {
        return null
    }
}

export default Localizer


// WEBPACK FOOTER //
// ./src/components/CustomComponents/Localization/Localizer/index.js